import { render, staticRenderFns } from "./orderDetailsAccount.vue?vue&type=template&id=0388cfba&scoped=true"
import script from "./orderDetailsAccount.vue?vue&type=script&lang=js"
export * from "./orderDetailsAccount.vue?vue&type=script&lang=js"
import style0 from "./orderDetailsAccount.vue?vue&type=style&index=0&id=0388cfba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0388cfba",
  null
  
)

export default component.exports